import {baseLocalConfig} from '../base/local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbssportsLocalConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseLocalConfig, {
  environmentName: "Cbs Sports Local Environment",
  ionicEnvName: 'local',
  loginFormLogo: './assets/logos/cbssports-logo.png',
  loginLogoClass: 'cbssportsLogo',
  loginPageClass: 'cbssportsLoginPageBackground',
  logoColor: 'blue',
  enabledContentFeatures: {
    video: {
      upload: false,
    },
  },
  requiredFields: {
    content_article: {
      draft: [
        'primaryTopic',
        'primaryAuthor',
      ],
      publish: [
        'articlePage',
        'type',
        'body',
        'source',
        'primaryTopic',
        'primaryAuthor',
        'editions',
        'promoHed',
      ],
      schedule: [
        'articlePage',
        'type',
        'body',
        'source',
        'primaryTopic',
        'primaryAuthor',
        'editions',
        'promoHed',
      ],
      preview: [
        'articlePage',
        'primaryTopic',
        'dek',
        'primaryAuthor',
      ],
    },
  },
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbssports/local.config.ts